import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppMarketReduxState, GlobalNotification } from './types';

const initialState: AppMarketReduxState = {};

export const appMarketSlice = createSlice({
  name: 'appMarketReduxState',
  initialState,
  reducers:{
    invalidateSession: (state) => {
      state.loggedOut = true;
    },
    showHideGlobalNotification: (state, action: PayloadAction<Maybe<GlobalNotification>>) => {
      state.globalNotification = action?.payload;
    }
  }

})

export const { invalidateSession, showHideGlobalNotification }  = appMarketSlice.actions
export default appMarketSlice.reducer
